import gql from "graphql-tag";

export const SUBSCRIBE_FEEDBACK_COUNT = gql`
subscription feedbackCount($filter: String!){
  feedbackCount: Feedback_aggregate (where:{_and: [ {_or: [{Customer: {name: {_ilike: $filter}}}, {Customer: {mobile: {_ilike: $filter}}}, {Customer: {email: {_ilike: $filter}}} ]}]}){
    aggregate{ count }
  }
}`

export const SUBSCRIBE_FEEDBACK = gql`
subscription feedback($offset: Int!, $limit: Int!, $filter: String!){
  Feedback (where:{_and: [ {_or: [{Customer: {name: {_ilike: $filter}}}, {Customer: {mobile: {_ilike: $filter}}}, {Customer: {email: {_ilike: $filter}}} ]}]},
                    offset: $offset, limit: $limit, order_by: {created_at: desc}){
    id
    feedback 
    Customer { id name mobile email city profileImage label SalesExecutive{ id name profileImage } }
    Attachments {id path}
    created_at
  }
}`